module.exports = __webpack_public_path__ + "img/trp_trgametokens.b3375a9.png";